import { Avatar } from "antd/lib";
import {
  getAppointMentStatus,
  getDurationInMinutes,
} from "../../utils/DateUtils";
import { UserOutlined } from "@ant-design/icons";
import { Popover } from "antd";
type Props = {
  // appointment: appointment;
  appointment: any; //for test the
  onClick?: (id: number) => void;
};
const statusColor = (status: string) => {
  switch (status) {
    case "completed":
      return "#479821";
    case "started":
      return "#CF953D";

    case "arrived":
      return "#CF953D";
    default:
      return "gray";
  }
};

const AppointmentRow = ({ appointment, onClick }: Props) => {
  const teamMembers: { id: number; name: string; media: string }[] = [];
  appointment?.appointment_services?.map(
    (item: { team_member: { id: number; name: string; media: string } }) => {
      if (
        item?.team_member &&
        !teamMembers?.find((member) => member?.id === item?.team_member?.id)
      ) {
        teamMembers.push(item?.team_member);
      }
    }
  );
  appointment?.appointment_packages?.map(
    (item: { team_member: { id: number; name: string; media: string } }) => {
      if (
        item?.team_member &&
        !teamMembers?.find((member) => member?.id === item?.team_member?.id)
      ) {
        teamMembers.push(item?.team_member);
      }
    }
  );
  console.log(teamMembers);
  return (
    <div
      className={
        " cursor-pointer rounded-lg grid text-sm grid-cols-6 bg-white items-center justify-center  py-3 px-5"
      }
      style={{ border: `1px ${statusColor(appointment?.status)} solid` }}
      onClick={() => onClick?.(appointment?.id)}
    >
      <div className="flex items-center gap-2 text-[#020418]">
        <Avatar.Group maxCount={5} size={30}>
          <>
            {teamMembers?.map((member) => (
              <Popover content={member?.name}>
                <Avatar
                  icon={<UserOutlined />}
                  key={member?.id}
                  src={member?.media}
                  style={{ backgroundColor: "gray" }}
                />
              </Popover>
            ))}
          </>
        </Avatar.Group>
      </div>
      <div className="flex items-center text-center w-full mx-auto text-sm text-color-primary font-semibold">
        #{appointment?.id}
      </div>
      <p
        className="flex items-center text-center w-full mx-auto text-sm font-semibold text-[#479821]"
        style={{ color: statusColor(appointment?.status) }}
      >
        {getAppointMentStatus(appointment?.status, "en")}
      </p>
      <p className="flex items-center text-center w-full mx-auto text-sm text-[#75757E]">
        {appointment?.date}
      </p>
      <p className="flex items-center text-center w-full mx-auto text-sm text-[#75757E]">
        {getDurationInMinutes(
          appointment?.start_time,
          appointment?.finish_time
        )}{" "}
        mins
      </p>
      <p className="flex items-center text-center w-full mx-auto text-sm text-color-primary">
        <div>{appointment?.cost + " SR"}</div>
      </p>
    </div>
  );
};

export default AppointmentRow;
